function showPopup(message) {
  let popup = document.querySelector('.popup');
  if (popup) {
    popup.style.display = 'block';
    popup.querySelector('.popup-value').textContent = message;
    document.querySelector('.close-popup').addEventListener('click', function (e) {
      e.preventDefault();
      popup.querySelector('.popup-value').textContent = '';
      popup.style.display = 'none'
    })
  }
}

function sendForm() {
  let form = document.querySelector('form.extra-from');
  let inputs = form.querySelectorAll('input[type="checkbox"]');
  let checkboxError = form.querySelector('.error');
  let phoneError = form.querySelector('.error-phone');
  let phoneInput = form.querySelector('#phone');
  let patternPhone = /^\+?[0-9]{9,12}$/;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    let inputPolicy = form.querySelector('input#policy').checked;
    let inputPersonal = form.querySelector('input#personal-data').checked;

    if (!iti.getNumber() || phoneInput.value === null || phoneInput.value === '') {
      phoneError.classList.remove('hidden');
      return;
    } else {
      phoneError.classList.add('hidden');
    }

    if (!inputPolicy || !inputPersonal) {
      checkboxError.classList.remove('hidden');
      return;
    } else {
      checkboxError.classList.add('hidden');
    }

    const phoneNumber = iti.getNumber();
    const form_data = {
      phone: phoneNumber,
      policy: inputPolicy ? "1" : "0",
      personal_data: inputPersonal ? "1" : "0"
    };

    // Wysyłanie formularza
    fetch('/send.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(form_data)
    })
      .then(response => {
        if (response.ok) {
          showPopup("Formularz został wysłany!");
          document.querySelector('.popup').classList.add('success');
          form.reset();
        } else {
          showPopup("Wystąpił błąd podczas wysyłania formularza!");
          document.querySelector('.popup').classList.add('error');
        }
      })
      .catch(error => {
        document.querySelector('.popup').classList.add('error');
        showPopup(`Błąd sieci: ${error.message}`);
      });
  });
}
sendForm();
